import { Check } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";

/** The "why {product}?" benefits strip shown below a product's purchase flow. */
export default function ProductBenefits({
  title,
  benefits,
}: {
  title: string;
  benefits: string[];
}) {
  return (
    <>
      <Typography fontWeight={"bold"} variant="overline">
        why {title}?
      </Typography>
      <Stack direction={"row"} alignItems={"center"} flexWrap={"wrap"}>
        {benefits.map((benefit) => (
          <Stack
            direction={"row"}
            spacing={2}
            key={benefit}
            alignItems={"center"}
            sx={{
              flexWrap: "nowrap",
              whiteSpace: "nowrap",
              mr: 4,
            }}
          >
            <Check color="primary" fontSize="small" />
            <Typography>{benefit}</Typography>
          </Stack>
        ))}
      </Stack>
    </>
  );
}
